
import { Card, List, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction } from "react";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";
import noImage from '../../../../images/no-image.png';

interface Props {
    items: any;
    isLoading: boolean;
    selectedItems: any;
    setSelectedItems: Dispatch<any>;
    setPage: Dispatch<SetStateAction<number>>;
    page: number;
    getItemsSearchMutation: UseMutateAsyncFunction<
        AxiosResponse<any, any>,
        unknown,
        void,
        unknown
    >;
    tableKey: string;
}

const CardsList = ({
    items,
    isLoading,
    selectedItems,
    setSelectedItems,
    setPage,
    page,
    tableKey,
    getItemsSearchMutation,
}: Props) => {
    const [t] = useTranslation("common");
    const { Text } = Typography;

    const handleCardClick = (record: any) => {
        const isChecked = selectedItems.some((item: any) => item.id === record.id);
        if (isChecked) {
            setSelectedItems(selectedItems.filter((item: any) => item.id !== record.id));
        } else {
            setSelectedItems([...selectedItems, record]);
        }
    };

    const baseURL = (window as any).REACT_APP_BASE_API_URL

    return (
        <List
            grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 4,
                xl: 5,
                xxl: 6,
            }}
            dataSource={items}
            renderItem={(record: any) => {
                const dollarSign = record.averagePriceText[0]
                const parts = record.lastPriceText.substring(1).split('.');
                const shortName = record.item.name.length > 49 ? record.item.name.length.substring(0, 46) + '...' : record.item.name
                const isSelected = selectedItems.some((item: any) => item.id === record.id);
                const imagePath = record.item.image ? baseURL + '/images/' + record.item.image : noImage
                return (
                    <List.Item>
                        <Card
                            key={record.id}
                            hoverable
                            loading={isLoading}
                            className="main ant-table-thead"
                            size="small"
                            onClick={() => handleCardClick(record)}
                            bodyStyle={{
                                paddingLeft: 10,
                                paddingTop: 10,
                            }}
                            style={{
                                borderRadius: 0,
                                marginTop: 10,
                                border: '1px solid #f0f0f0',
                                boxShadow: isSelected ? '0 0 10px rgb(22, 119, 255)' : '',
                            }}
                            title={<div
                                style={{
                                    display: 'flex',
                                    height: '200px',
                                    justifyContent: 'center',
                                    position: 'relative',
                                    minWidth: '145px',
                                    backgroundColor: '#F7F8F8'
                                }}>
                                <img
                                    style={{
                                        border: 0,
                                        margin: 'auto',
                                        maxHeight: '184px',
                                        maxWidth: '224px'
                                    }}
                                    alt={record.item.name}
                                    src={imagePath}
                                />
                            </div>}
                            headStyle={{
                                padding: 0,
                            }}
                        >
                            <div style={{ height: '50px' }}><h3>{shortName}</h3></div>
                            <h2 style={{ fontSize: 28 }}><sup style={{ fontSize: 13 }}>{dollarSign}</sup>{parts[0]}<sup><span style={{ fontSize: 13 }}>{parts[1]}</span></sup></h2>
                            <Text style={{ fontSize: 14, fontWeight: 'bold' }}>{`${t("quantity-available")}:`} {record.currentQuantity}</Text>
                            <h4>{`${record.item.barcode}`}</h4>
                        </Card>
                    </List.Item>
                )
            }}
        />
    );
};

export default CardsList;
